module.exports = __webpack_public_path__ + "static/media/preview_file.64e05fe8.svg";